export const changeWeatherForecastReducer = (state = null, action) => {
  switch (action.type) {
    case "CHANGE_WEATHER_FORECAST":
      return action.payload.weatherForecast;
    default:
      return state;
  }
};
